import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from '@services/token/token.service';
import { environment } from 'environments/environment';
import { ICreateSalvageAuctionResponse } from 'models/salvage.model';

@Injectable({
  providedIn: 'root',
})
export class SalvageService {
  public searchElement = [
    'Make',
    'Model',
    'Model Year',
    'Body Type',
    'Trim/Type',
    'Exterior Colour',
    'VIN Number',
    'Plate Number',
  ];
  constructor(private _token: TokenService, public http: HttpClient) {}

  getSalvageList(url: string, options: Parameters<HttpClient['get']>['1']) {
    return this.http.get(url, {
      headers: this._token.getTokenHeader(),
      ...options,
    });
  }
  getSalvageFilter(
    options: Parameters<HttpClient['get']>['1'],
    url: string = `${environment.v5}salvage/product/filter`
  ) {
    return this.http.get(url, {
      headers: this._token.getTokenHeader(),
      ...options,
    });
  }
  createSalvageAuction(
    url: string,
    body: Parameters<HttpClient['post']>['1'],
    options?: Parameters<HttpClient['post']>['2']
  ) {
    return this.http.post<ICreateSalvageAuctionResponse>(url, body, {
      headers: this._token.getTokenHeader(),
      ...options,
    });
  }

  getSalvageAuction<T>(
    options: Parameters<HttpClient['get']>['1'],
    url: string = `${environment.v5}salvage/auction`
  ) {
    return (
      this.http
        // Here
        .get<T>(url, {
          headers: this._token.getTokenHeader(),
          ...options,
        })
    );
  }

  getSalvageBuyNowAuction<T>(
    options: Parameters<HttpClient['get']>['1'],
    url: string = `${environment.v5}/salvage/auction/buy-now`
  ) {
    // const url = `${environment.v5}salvage/auction/buy-now`;
    return (
      this.http
        // Here
        .get<T>(url, {
          headers: this._token.getTokenHeader(),
          ...options,
        })
    );
  }

  getSalvageClosedAuction<T>(
    options: Parameters<HttpClient['get']>['1'],
    url: string = `${environment.v5}salvage/auction/close`
  ) {
    return (
      this.http
        // Here
        .get<T>(url, {
          headers: this._token.getTokenHeader(),
          ...options,
        })
    );
  }

  getSalvageCompletePaymentAuction<T>(
    options: Parameters<HttpClient['get']>['1'],
    url: string = `${environment.v5}salvage/payment`
  ) {
    return (
      this.http
        // Here
        .get<T>(url, {
          headers: this._token.getTokenHeader(),
          ...options,
        })
    );
  }

  getActiveSalvageAuction<T>(
    options: Parameters<HttpClient['get']>['1'],
    url: string = `${environment.v5}salvage/active`
  ) {
    return (
      this.http
        // Here
        .get<T>(url, {
          headers: this._token.getTokenHeader(),
          ...options,
        })
    );
  }

  getUpcomingSalvageAuction<T>(
    options: Parameters<HttpClient['get']>['1'],
    url: string = `${environment.v5}salvage/upcoming`
  ) {
    return (
      this.http
        // Here
        .get<T>(url, {
          headers: this._token.getTokenHeader(),
          ...options,
        })
    );
  }

  editAuction(auction_data: Object) {
    const URL = `${environment.v5}salvage/auction/update`;

    return this.http.post(URL, auction_data, {
      headers: this._token.getTokenHeader(),
    });
  }
}
